@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    @if(hulpmiddelen.length > 0) {
      <div formArrayName="hulpmiddelen">
        @for (item of hulpmiddelen.controls; track item; let i = $index) {
          <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <snelstart-ui-text-form-control [label]="i === 0 ? 'Hulpmiddelen' : ''"
                                          class="col-auto custom-input-250"
                                          formControlName="omschrijving"
                                          id="omschrijving"
          >

          </snelstart-ui-text-form-control>
          <snelstart-ui-number-form-control [decimals]="0"
                                            [label]="i === 0 ? 'Bedrag' : ''"
                                            [required]=true
                                            align="right"
                                            class="col-auto custom-input-150"
                                            formControlName="bedrag"
                                            id="bedrag"
                                            prefix="€"

          >
          </snelstart-ui-number-form-control>
          <snelstart-ui-button (click)="verwijderRijHulpmiddelen(i)"
                               [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                               icon="trash"
                               iconType="light"
                               id="buttonDeleteKosten"
                               size="medium"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
        }
      </div>
    }
  </form>

  <snelstart-ui-button (click)="addRijHulpmiddelen()" class="snelstart-ui-button pb-3" icon="plus"
                       type="link">Hulpmiddellen
  </snelstart-ui-button>
}
